import { render } from "./Technologies.vue?vue&type=template&id=5c2c2e57"
import script from "./Technologies.vue?vue&type=script&lang=js"
export * from "./Technologies.vue?vue&type=script&lang=js"

import "./Technologies.vue?vue&type=style&index=0&id=5c2c2e57&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__